import { useLoaderData } from "react-router";

import Sidebar from "@/components/Sidebar";

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
function shuffle(array) {
  let currentIndex = array.length;

  while (currentIndex != 0) {
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
}

export function Photos() {
  document.title = "Photos | Katelynn & Thomas";
  const { count } = useLoaderData();
  let imgs = [];
  for (let i = 1; i < count + 1; i++) {
    const name = "/public/us/img_" + i.toString().padStart(3, '0') + ".jpg?quality=60";
    const className = Math.floor(Math.random() * 3) ? "md:col-span-1" : "md:col-span-2";
    imgs.push((
      <div key={name} className={`${className} col-span-3 relative group h-100`}>
        <img
          loading="lazy"
          className="w-full h-full rounded-xl drop-shadow-xl object-cover
                     transition-all duration-150 ease-in-out
                     md:group-hover:scale-120 md:group-hover:z-50 md:group-hover:drop-shadow-2xl
                     relative md:group-hover:absolute md:group-hover:inset-0"
          sizes="(max-width: 768px) 100vw, 50vw"
          srcSet={`
            ${name}&size=400 400w,
            ${name}&size=800 800w,
            ${name}&size=1200 1200w
          `}
          src={`${name}&size=800`}
        />
      </div>
    ))
  }

  shuffle(imgs);

  return (
    <div className="p-4 h-full w-full flex flex-row justify-center items-center max-w-7xl mx-auto">
      <div className="h-full w-full grid grid-cols-1 md:grid-cols-5 gap-4">
        <Sidebar />
        <div className="bg-light dark:bg-dark rounded-2xl drop-shadow-2xl col-span-1 md:col-span-4 p-6 grid grid-cols-3 grid-flow-dense gap-4 post overflow-visible">
          {imgs}
        </div>
      </div>
    </div>
  );
}

export default Photos;
